import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, pluck, switchMap } from 'rxjs/operators';

import { Candidate } from '@shared/models';
import { AttachmentParams, AttachmentService } from '@shared/services';
import { CandidateService } from '@shared/services/candidate.service';

import {
  CandidatesUploadGetFail,
  CandidatesUploadSelect,
  CandidateUploadActionTypes,
  UploadResumeFailure,
  UploadResumeSuccess,
} from './candidate-upload.actions';

@Injectable()
export class CandidateUploadEffects {
  getCandidate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CandidateUploadActionTypes.GetCandidateByEmail),
      pluck('payload'),
      switchMap((body) =>
        this.candidateService.postByEmail(body).pipe(
          map((savedCandidate: Candidate) => new CandidatesUploadSelect(savedCandidate.id)),
          catchError(() => of(new CandidatesUploadGetFail())),
        ),
      ),
    ),
  );

  uploadSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CandidateUploadActionTypes.Upload),
      pluck('payload'),
      switchMap(({ file, id }) => {
        const attachment: AttachmentParams = {
          associateModuleId: id,
          associationModule: AttachmentService.AssociationModule.CANDIDATE,
          associationType: AttachmentService.AssociationType.RESUME,
        };
        return this.attachmentService.save(file, attachment).pipe(
          map(() => new UploadResumeSuccess()),
          catchError(() => of(new UploadResumeFailure())),
        );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private store: Store<{}>,
    private candidateService: CandidateService,
    private attachmentService: AttachmentService,
  ) {}
}
